import { render } from "./SingleRecord.vue?vue&type=template&id=397ccb3a&scoped=true"
import script from "./SingleRecord.vue?vue&type=script&lang=js"
export * from "./SingleRecord.vue?vue&type=script&lang=js"

import "./SingleRecord.vue?vue&type=style&index=0&id=397ccb3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397ccb3a"]])

export default __exports__